import moment, { type Moment } from 'moment';
import { DateFormats, BACKEND_DATE_FORMATS } from '#app/helpers/DateFormats';

/**
 * Парсинг основного поля даты с бэка (Y-m-d H:i:s), user-форматов, Date или Moment.
 */
export const parseAtValue = (value: unknown): Moment | null => {
  if (value == null || value === '') {
    return null;
  }

  if (moment.isMoment(value)) {
    return value.isValid() ? value.clone() : null;
  }

  if (value instanceof Date) {
    const fromDate = moment(value);
    return fromDate.isValid() ? fromDate : null;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const fromTs = moment(value);
    return fromTs.isValid() ? fromTs : null;
  }

  const strict = moment(String(value), BACKEND_DATE_FORMATS, true);
  if (strict.isValid()) {
    return strict;
  }

  const loose = moment(String(value), BACKEND_DATE_FORMATS);
  return loose.isValid() ? loose : null;
};

/** DD.MM.YYYY из основного поля. */
export const formatAtDate = (value: unknown, empty = ''): string => {
  const parsed = parseAtValue(value);
  return parsed ? parsed.format(DateFormats.USER_DATE) : empty;
};

/** DD.MM.YYYY HH:mm:ss из основного поля. */
export const formatAtDateTime = (value: unknown, empty = ''): string => {
  const parsed = parseAtValue(value);
  return parsed ? parsed.format(DateFormats.USER_DATETIME) : empty;
};

export const parseAtToDate = (value: unknown): Date | null => {
  const parsed = parseAtValue(value);
  return parsed ? parsed.toDate() : null;
};

/** Дата платежа: paid_at, иначе legacy paid_at_datetime / paid_at_date (index-grid). */
export const parsePaymentPaidAt = (
  payment: Record<string, unknown> | null | undefined,
  primaryField = 'paid_at'
): Moment | null => {
  if (!payment) {
    return null;
  }

  const fields = [primaryField, 'paid_at', 'paid_at_datetime', 'paid_at_date'];
  const seen = new Set<string>();

  for (const field of fields) {
    if (!field || seen.has(field)) {
      continue;
    }
    seen.add(field);
    const parsed = parseAtValue(payment[field]);
    if (parsed) {
      return parsed;
    }
  }

  return null;
};
